import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useGetPublisherQuery } from '../../../api/publisherApiSlice';
import Title from '../../../components/Title';
import { useTranslation } from 'react-i18next';
import { CredentialTesterButton } from '../../../components/publisher/CredentialTesterButton';
import { CredentialBlock } from '../../../components/publisher/CredentialBlock';

const Credentials = () => {
  const publisherId = useParams()["publisherId"];
  const { data: publisher, isSuccess } = useGetPublisherQuery({publisherId})
	const { t } = useTranslation();
  const history = useHistory();

  if(!isSuccess ) { return (<></>) }

  return(<>
      <Title main={publisher.name} sub={t('credentials')} onBack={()=>(history.push(`/publishers/${publisherId}`))}>
        <CredentialTesterButton slug={publisherId} />
      </Title>
      <CredentialBlock publisher={publisher}/>
  </>)
}

export default Credentials
